export * from './lib/highlight-pipe.module';
export * from './lib/highlight.pipe';
